import { nextstepsConstants } from '../constants/actionTypes'

let initialState = { step: '', link: '', isFetching: false }

export const nextSteps = (state = initialState, action) => {
  switch (action.type) {
    case nextstepsConstants.FETCH_NEXTSTEPS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case nextstepsConstants.FETCH_NEXTSTEPS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}
